import { useState } from 'react';

import { useGetSharedFunctionality } from '../../api/lending/lapiHooks';
import { SellerInnerPageTemplate } from '../../routing/templates';
import { CustomersTable } from './components/CustomersTable/CustomersTable';
import { CustomersToolbar } from './components/CustomersToolbar/CustomersToolbar';
import { useTrackCustomersPageView } from './hooks/useTrackCustomersPageView';

export const Customers = () => {
  const { functionality } = useGetSharedFunctionality();
  const isSharedSpendingLimitEnabled = Boolean(
    functionality?.is_shared_spending_limit_enabled,
  );

  useTrackCustomersPageView({ enabled: isSharedSpendingLimitEnabled });

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchQuery, setSearchQuery] = useState<string>();

  if (!isSharedSpendingLimitEnabled) return null;

  return (
    <SellerInnerPageTemplate title="Customers">
      <div className="flex flex-col gap-xl">
        <div className="text-m font-reg">
          Track which customers have been approved for iwocaPay Spending Limits,
          how much credit they have left, and where they are in their onboarding
          journey. These limits are shared universally across all iwocaPay
          suppliers.
        </div>
        <CustomersToolbar
          setCurrentPage={setCurrentPage}
          setSearchQuery={setSearchQuery}
        />
        <CustomersTable
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          searchQuery={searchQuery}
        />
      </div>
    </SellerInnerPageTemplate>
  );
};
